import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { Box, Button, TextField, Typography, styled } from '@mui/material';

import type { AddDiscountCodeInputModel } from '@/hooks/discount-code/useAddDiscountCode';

const TERMS_URL = 'https://www.alternaleaf.com.au/promotion-terms';

const Row = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: '1rem',
  marginBottom: '1rem',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    alignItems: 'baseline',
  },
}));

const ApplyButton = styled(Button)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    minWidth: 'auto',
  },
}));

function inputFeedbackProps({
  validated,
  message,
  isApplying,
}: {
  validated?: boolean;
  message?: string;
  isApplying: boolean;
}) {
  return {
    InputProps: {
      endAdornment:
        isApplying || typeof validated !== 'boolean' ? null : validated === true ? (
          <CheckCircleIcon fontSize="large" color="success" />
        ) : (
          <ErrorIcon fontSize="large" color="error" />
        ),
    },
    helperText: message ? (
      <Typography component="span">
        {message}{' '}
        <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" style={{ color: '#1E0421' }}>
          View full offer terms and conditions.
        </a>
      </Typography>
    ) : null,
  };
}

export function DiscountCodeInput(props: AddDiscountCodeInputModel) {
  const { value, onChange, onKeyDown, onApply, isApplying, validated, helperMessage } = props;

  return (
    <Row>
      <TextField
        id="input-promo-code"
        type="text"
        variant="filled"
        fullWidth
        placeholder="Enter code"
        {...inputFeedbackProps({
          validated,
          message: helperMessage,
          isApplying,
        })}
        disabled={isApplying}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
      />
      <Box>
        <ApplyButton disabled={isApplying} variant="contained" onClick={onApply} id="apply-promo-code">
          Apply
        </ApplyButton>
      </Box>
    </Row>
  );
}
